import { render } from "./bookingDetail.vue?vue&type=template&id=7681496a&scoped=true"
import script from "./bookingDetail.vue?vue&type=script&lang=js"
export * from "./bookingDetail.vue?vue&type=script&lang=js"

import "./bookingDetail.vue?vue&type=style&index=0&id=7681496a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7681496a"]])

export default __exports__